const isUpdate = ({ pointListForUI, targetGroup }) => {
  const pointListIsUpdated = pointListForUI.some(
    point => point.updated === true,
  )
  const targetGroupIsUpdated = targetGroup.updated
  return pointListIsUpdated || targetGroupIsUpdated
}

export default isUpdate
